import React from 'react';
import { useGetTruckers } from 'api/truckers/truckers';
import { GetTruckerParams, Trucker } from 'api/truckers/truckers.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableTruckerAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  disableClearable?: boolean;
}

export const EditableTruckerAutocomplete: React.FC<
  EditableTruckerAutocompleteProps
> = ({ disableClearable = false, ...props }) => (
  <EditableAutocomplete<Trucker, GetTruckerParams>
    {...props}
    disableClearable={disableClearable}
    useApiHook={useGetTruckers}
    getterName='getTruckers'
    defaultParams={{
      filterText: '',
      resultSize: 25,
      pageNumber: 1,
      withValidLicenseAndInsurance: true,
    }}
    mapOptions={(data: Trucker[]) =>
      data.map((trucker) => ({
        ...trucker,
        enabled:
          trucker.businessFunctions.find(
            (businessFunction: any) => businessFunction.__type === 'Trucker',
          )?.enabled ?? false,
      }))
    }
    getOptionLabel={(o) => {
      if (typeof o === 'string') return o;
      return o.code || '';
    }}
    isOptionEqualToValue={(option, selectedValue) => {
      if (typeof selectedValue === 'string') {
        return option?.code === selectedValue;
      }
      return selectedValue?.id === option?.id;
    }}
    width={undefined}
  />
);
